import { Link } from "react-router-dom"
import Content from "../../../components/Content"
import { useAppSelector } from "../../../store/store"
import config from "../../../config"

const PlayerTeamsPage = () => {
    const playerPage = useAppSelector(state => state.playerPage)
    return (
        <Content className="flex flex-col gap-5">
            {(playerPage.teams?.length || 0) > 0 ?
                playerPage?.teams?.map((teamMember) => (
                    <div key={teamMember.id} className="flex items-center gap-5 border p-5">
                        <img className="min-w-[75px] max-w-[75px] min-h-[75px] max-h-[75px] rounded-full" src={`${config.API_URL}/teams/${teamMember.team?.id}/logo`} alt={`${teamMember.team?.name}_logo`} />
                        <div className="flex flex-col overflow-hidden">
                            <Link className="text-lg font-bold text-zinc-700 hover:underline" to={`/teams/${teamMember.team?.slug}`}>{teamMember.team?.name}</Link>
                            <p className="text-zinc-700 truncate">{teamMember.team?.description}</p>
                            {(teamMember.team?.founded_by?.id === playerPage.id || teamMember.admin) &&
                                <div className="flex gap-2 mt-2">
                                    {teamMember.team?.founded_by?.id === playerPage.id && <span className="bg-red-500 rounded-full px-2 py-1 flex items-center justify-center text-sm uppercase text-white">Fundador</span>}
                                    {teamMember.admin && <span className="bg-blue-500 rounded-full px-2 py-1 flex items-center justify-center text-sm uppercase text-white">Admin</span>}
                                </div>
                            }
                        </div>
                    </div>
                ))
                :
                <p className="text-sm uppercase text-zinc-700">Aún no pertenece a ningún equipos.</p>
            }
        </Content>
    )
}

export default PlayerTeamsPage